<template>
  <b-container fluid>
    <b-overlay :show="loading">
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(createData)" @reset.prevent="reset" >
                    <iq-card>
                        <template v-slot:headerTitle>
                            <h4 class="card-title">{{ $t('production_configuration.supplier_info') }}</h4>
                        </template>
                        <template v-slot:body>
                            <b-row>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Year of Registration" vid="registration_year" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="registration_year"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_service_config.year_of_reg')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input  type="number"
                                        id="registration_year"
                                        v-model="supplierInfo.registration_year"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Supplier Code" vid="supplier_code" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="supplier_code"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.supplier_code')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="supplier_code"
                                        v-model="supplierInfo.supplier_code"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Company Name (En)" vid="company_name" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="company_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.company_name_en')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="company_name"
                                        v-model="supplierInfo.company_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Company Name (Bn)" vid="company_name_bn" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="company_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.company_name_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="company_name_bn"
                                        v-model="supplierInfo.company_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Supplier Name (En)" vid="name_en" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="name_en"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.supplier_name_en')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="name_en"
                                        v-model="supplierInfo.name_en"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Supplier Name (Bn)" vid="name_bn" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.supplier_name_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="name_bn"
                                        v-model="supplierInfo.name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Father’s Name (En)" vid="father_name_en">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="father_name_en"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.father_name_en')}}
                                        </template>
                                        <b-form-input
                                        id="father_name_en"
                                        v-model="supplierInfo.father_name_en"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Father’s Name (Bn)" vid="father_name_bn">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="father_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_configuration.father_name_bn')}}
                                        </template>
                                        <b-form-input
                                        id="father_name_bn"
                                        v-model="supplierInfo.father_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="TIN No" vid="tin_no" rules="required|numeric">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="tin_no"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_service_config.tin_no')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="tin_no"
                                        v-model="supplierInfo.tin_no"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="NID" vid="nid" rules="required|numeric">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="nid"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_service_config.nid')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="nid"
                                        v-model="supplierInfo.nid"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="NID (Attachment)" vid="nid_attachment">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        :label="$t('production_service_config.nid_attach')"
                                        label-for="nid_attachment"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{$t('production_service_config.nid_attach')}}
                                        </template>
                                        <b-row v-if="supplierInfo.nid_attachment">
                                            <b-col cols="10">
                                                <b-form-file
                                                id="nid_attachment"
                                                v-on:change="onFileChange"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-file>
                                            </b-col>
                                            <b-col>
                                                <a :href="baseUrl + 'download-attachment?file=uploads/config/SupplierInfo/nidoriginal/' + supplierInfo.nid_attachment" title="NID Attachment Download"><i class="ri-download-cloud-fill"></i></a>
                                            </b-col>
                                        </b-row>
                                        <b-form-file v-else
                                        id="nid_attachment"
                                        v-on:change="onFileChange"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-file>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Contact No" vid="contact_no" rules="required|numeric|min:11|max:11">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="contact_no"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_service_config.contact_no')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="contact_no"
                                        v-model="supplierInfo.contact_no"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Email" vid="email" rules="required|email">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="email"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                        {{$t('production_service_config.email')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                        id="email"
                                        v-model="supplierInfo.email"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </template>
                    </iq-card>
                    <iq-card>
                        <template v-slot:headerTitle>
                            <h4 class="card-title">{{ $t('production_service_config.present_address') }}</h4>
                        </template>
                        <template v-slot:body>
                            <b-row>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="division_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('org_pro_division.division')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.division_id"
                                            :options="divisionList"
                                            id="division_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="district_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('org_pro_district.district')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.district_id"
                                            :options="districtList"
                                            id="district_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Upazila" vid="upazila_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="upazila_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_upazilla.upazilla')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.upazila_id"
                                            :options="upazilaList"
                                            id="upazila_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Union" vid="union_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="union_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_union.union')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.union_id"
                                            :options="unionList"
                                            id="union_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Address (en)" vid='address_en'>
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="address_en"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                            {{ $t('production_service_config.address_en')}}
                                            </template>
                                            <b-form-input
                                            id="address_en"
                                            v-model="supplierInfo.address_en"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Address (bn)">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="address_bn"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('production_service_config.address_bn')}}
                                            </template>
                                            <b-form-input
                                            id="address_bn"
                                            v-model="supplierInfo.address_bn"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </template>
                    </iq-card>
                    <ValidationProvider name="Is Same as Present Address" vid="is_same">
                        <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="is_same"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                            {{ $t('production_service_config.is_same_address') }}
                        </template>
                        <b-form-checkbox
                            id="is_same"
                            v-model="supplierInfo.is_same"
                            @change="isSameAsPermanent"
                            value="2"
                            unchecked-value=""
                            :state="errors[0] ? false : (valid ? true : null)"
                            >{{ $t('production_service_config.yes') }}</b-form-checkbox>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                    <iq-card v-if="isShow">
                        <template v-slot:headerTitle>
                            <h4 class="card-title">{{ $t('production_service_config.permanent_address') }}</h4>
                        </template>
                        <template v-slot:body>
                            <b-row>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Division" vid="per_division_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="per_division_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('org_pro_division.division')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.per_division_id"
                                            :options="divisionList2"
                                            id="per_division_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="District" vid="per_district_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="per_district_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('org_pro_district.district')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.per_district_id"
                                            :options="districtList2"
                                            id="per_district_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Upazila" vid="per_upazila_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="per_upazila_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_upazilla.upazilla')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.per_upazila_id"
                                            :options="upazilaList2"
                                            id="per_upazila_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Union" vid="per_union_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="per_union_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_union.union')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="supplierInfo.per_union_id"
                                            :options="unionList2"
                                            id="per_union_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Address (en)" vid='per_address_en'>
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="per_address_en"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                            {{ $t('production_service_config.address_en')}}
                                            </template>
                                            <b-form-input
                                            id="per_address_en"
                                            v-model="supplierInfo.per_address_en"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Address (bn)">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="per_address_bn"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('production_service_config.address_bn')}}
                                            </template>
                                            <b-form-input
                                            id="per_address_bn"
                                            v-model="supplierInfo.per_address_bn"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </template>
                    </iq-card>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                        &nbsp;
                        <router-link to="/production-service/configuration/supplier-info" :class="'btn btn-danger text-light'">{{  $t('globalTrans.cancel') }}</router-link>
                      </div>
                    </div>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { supplierInfoStore, supplierInfoUpdate, supplierInfoShow } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.$route.query.id) {
      this.getSupplierData(this.$route.query.id)
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
        isShow: true,
        loading: false,
        baseUrl: productionServiceBaseUrl,
        saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
        supplierInfo: {
            id: '',
            name_en: '',
            name_bn: '',
            father_name_en: '',
            father_name_bn: '',
            company_name: '',
            company_name_bn: '',
            registration_year: '',
            supplier_code: '',
            contact_no: '',
            email: '',
            nid: '',
            nid_attachment: '',
            tin_no: '',
            is_same: '',
            division_id: '0',
            district_id: '0',
            upazila_id: '0',
            union_id: '0',
            address_en: '',
            address_bn: '',
            per_division_id: '0',
            per_district_id: '0',
            per_upazila_id: '0',
            per_union_id: '0',
            per_address_en: '',
            per_address_bn: '',
            status: ''
        },
        nid_attachment_two: '',
        districtList: [],
        upazilaList: [],
        unionList: [],
        cityCorporationList: [],
        pauroshobaList: [],
        wardList: [],
        districtList2: [],
        upazilaList2: [],
        unionList2: [],
        cityCorporationList2: [],
        pauroshobaList2: [],
        wardList2: []
    }
  },
  computed: {
    divisionList: function () {
        return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    divisionList2: function () {
        return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    }
  },
  watch: {
    'supplierInfo.division_id': function (newVal, oldVal) {
        this.districtList = this.getDistrictList(newVal)
    },
    'supplierInfo.district_id': function (newVal, oldVal) {
        this.cityCorporationList = this.getCityCorporationList(newVal)
        this.upazilaList = this.getUpazilaList(newVal)
    },
    'supplierInfo.upazila_id': function (newVal, oldVal) {
        this.unionList = this.getUnionList(newVal)
        this.pauroshobaList = this.getPauroshobaList(newVal)
    },
    'supplierInfo.union_id': function (newVal, oldVal) {
        this.wardList = this.getWardListByUnion(newVal)
    },
    'supplierInfo.per_division_id': function (newVal, oldVal) {
        this.districtList2 = this.getDistrictList2(newVal)
    },
    'supplierInfo.per_district_id': function (newVal, oldVal) {
        this.cityCorporationList2 = this.getCityCorporationList2(newVal)
        this.upazilaList2 = this.getUpazilaList2(newVal)
    },
    'supplierInfo.per_upazila_id': function (newVal, oldVal) {
        this.unionList2 = this.getUnionList2(newVal)
        this.pauroshobaList2 = this.getPauroshobaList2(newVal)
    },
    'supplierInfo.per_union_id': function (newVal, oldVal) {
        this.wardList2 = this.getWardListByUnion2(newVal)
    }
  },
  methods: {
    async getSupplierData (id) {
        const result = await RestApi.getData(productionServiceBaseUrl, supplierInfoShow + '/' + id)
        if (result.success) {
            this.supplierInfo = result.data
        } else {
            this.supplierInfo = {}
        }
    },
    onFileChange (e) {
      this.nid_attachment_two = e.target.files[0]
    },
    async createData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: false }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      this.loading = true
      var formData = new FormData()
      Object.keys(this.supplierInfo).map(key => {
        if (key === 'nid_attachment') {
          formData.append(key, this.nid_attachment_two)
        } else {
          formData.append(key, this.supplierInfo[key])
        }
      })
      if (this.supplierInfo.id) {
        formData.append('_method', 'PUT')
        result = await RestApi.postData(productionServiceBaseUrl, `${supplierInfoUpdate}/${this.supplierInfo.id}`, formData, config)
      } else {
        result = await RestApi.postData(productionServiceBaseUrl, supplierInfoStore, formData, config)
      }
      loadinState.listReload = true

      this.$store.dispatch('mutateCommonProperties', loadinState)

      if (result.success) {
        this.$store.dispatch('mutateWarehouseProperties', { hasDropdownLoaded: false })
        this.$toast.success({
          title: 'Success',
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })
        this.$bvModal.hide('modal-4')
        this.$router.push('/production-service/configuration/supplier-info')
      } else {
        this.$refs.form.setErrors(result.errors)
      }
    },
    getDistrictList (divisionId = null) {
        const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

        if (divisionId) {
            return districtList.filter(district => district.division_id === divisionId)
        }

        return districtList
    },
    getUpazilaList (districtId = null) {
        const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

        if (districtId) {
            return upazilaList.filter(upazila => upazila.district_id === districtId)
        }

        return upazilaList
    },
    getUnionList (upazilaId = null) {
        const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
        if (upazilaId) {
            return unionList.filter(union => union.upazilla_id === upazilaId)
        }

        return unionList
    },
    getCityCorporationList (districtId) {
        const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getPauroshobaList (upazillaId = null) {
        const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
        if (upazillaId) {
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    getWardListByUnion (unionId) {
        const objectData = this.$store.state.commonObj.wardList
        const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text }
            }
        })
    },
    getDistrictList2 (divisionId = null) {
        const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

        if (divisionId) {
            return districtList.filter(district => district.division_id === divisionId)
        }

        return districtList
    },
    getUpazilaList2 (districtId = null) {
        const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

        if (districtId) {
            return upazilaList.filter(upazila => upazila.district_id === districtId)
        }

        return upazilaList
    },
    getUnionList2 (upazilaId = null) {
        const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
        if (upazilaId) {
            return unionList.filter(union => union.upazilla_id === upazilaId)
        }

        return unionList
    },
    getCityCorporationList2 (districtId) {
        const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getPauroshobaList2 (upazillaId = null) {
        const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
        if (upazillaId) {
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    getWardListByUnion2 (unionId) {
        const objectData = this.$store.state.commonObj.wardList
        const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text }
            }
        })
    },
    isSameAsPermanent () {
        if (this.supplierInfo.is_same === '') {
            this.isShow = true
        } else {
            this.isShow = false
        }
    }
  }
}
</script>
